import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { ImageCategory } from '../../shared/state/utils';

type CategoryButtonProps = {
    isVisible: boolean;
    effectiveCategory: number;
}

export const CategoryButton = styled(Button, {
    shouldForwardProp: (prop) => prop !== 'isVisible' && prop !== 'effectiveCategory'
})<CategoryButtonProps>(({ isVisible, effectiveCategory }) => ({
    fontSize: '11px',
    textTransform: 'none',
    padding: '2px 8px',
    minWidth: 0,
    visibility: isVisible ? 'visible' : 'hidden',
    color: effectiveCategory === ImageCategory.Normal ? '#d32f2f' : '#3b873e',
    '&:hover': {
        backgroundColor:
            effectiveCategory === ImageCategory.Normal
                ? 'rgba(211,47,47,0.08)'
                : 'rgba(59,135,62,0.08)'
    }
}));
